import '../../monitoring/select_view.js.coffee'
Namespace 'Customer.Filters'

class Customer.Filters.GroupSelectView extends App.GroupSelectView
  className: 'customer-filters-select-view'
  titleTemplate: JST['backbone/templates/customer/filters/group_select_title']

  initialize: ({options, valueProperty, descriptionProperty, selectedOptions, placeholder, editable, title}) ->
    @title = title || ''
    super({options, valueProperty, descriptionProperty, selectedOptions, placeholder, editable})

  render: =>
    super()
    @$el.prepend(@titleTemplate(title: @title))
    @$el.find('.tags').addClass('mini-scrollbar')
    @

  _optionClass: (option) ->
    option['optionClass']
